export default __webpack_public_path__ + "static/media/illustration-algohealth-w.2d181157.webp";